import { Download, FileSpreadsheet, Upload } from 'lucide-react';
import type { Museum } from '../data/types';
import { useT } from '../hooks/useT';
import { backupNaarJson, maakBackup, statusNaarCsv } from '../utils/backup';
import { datumKort } from '../utils/datum';
import { downloadBestand } from '../utils/download';
import type { KaartInfo, StatusMap } from '../utils/museum';
import { vandaag } from '../utils/museum';
import { chip } from '../utils/ui';

interface BackupSectieProps {
  musea: Museum[];
  status: StatusMap;
  kaart: KaartInfo;
  laatsteBackup: string | null;
  onBackupGemaakt: (datum: string) => void;
  onMelding: (tekst: string) => void;
  onHerstel: () => void;
}

/** Back-up maken, als CSV exporteren en terugzetten. Staat in het menu. */
export function BackupSectie({ musea, status, kaart, laatsteBackup, onBackupGemaakt, onMelding, onHerstel }: BackupSectieProps) {
  const { t, tf, language } = useT();

  const maakBackupBestand = () => {
    const ok = downloadBestand(`museumkompas-backup-${vandaag()}.json`, backupNaarJson(maakBackup(status, kaart)), 'application/json');
    if (ok) {
      onBackupGemaakt(vandaag());
      onMelding(t('backupOpgeslagen'));
    } else onMelding(t('shareFailedToast'));
  };

  const maakCsvBestand = () => {
    const ok = downloadBestand(`museumkompas-${vandaag()}.csv`, statusNaarCsv(musea, status), 'text/csv', true);
    onMelding(ok ? t('csvOpgeslagen') : t('shareFailedToast'));
  };

  return (
    <section className="space-y-3 border-t border-black/5 pt-6 dark:border-white/10" aria-labelledby="backup-titel">
      <h3 id="backup-titel" className="font-semibold">{t('backupTitel')}</h3>
      <p className="text-sm text-slate-600 dark:text-slate-400">{t('backupUitleg')}</p>
      <p className="text-sm font-semibold">
        {laatsteBackup ? tf('backupLaatst', { datum: datumKort(laatsteBackup.slice(0, 10), language) }) : t('backupGeen')}
      </p>
      <div className="flex flex-wrap gap-2">
        <button onClick={maakBackupBestand} className={chip(false)}>
          <Download size={18} aria-hidden /> {t('backupMaak')}
        </button>
        <button onClick={maakCsvBestand} className={chip(false)}>
          <FileSpreadsheet size={18} aria-hidden /> {t('backupCsv')}
        </button>
        <button onClick={onHerstel} className={chip(false)}>
          <Upload size={18} aria-hidden /> {t('backupHerstel')}
        </button>
      </div>
    </section>
  );
}
